import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CheckedBool } from 'src/types/addToClio'

export interface AddToClioState {
  errorMessage: string
  checkedBool: CheckedBool
  progress: number
  connection: string
  maxMessageCount: number
  redirectUrl: string
  email: string
}

export const initialState: AddToClioState = {
  errorMessage: '',
  checkedBool: {
    'Corvum Account Created': false,
    'Phone Number Added': false,
    'Clio Account Connected': false,
    'Welcome Email Sent': false,
    'Check Email For Login Credentials': false
  },
  progress: 0,
  connection: '',
  maxMessageCount: 0,
  redirectUrl: '',
  email: ''
}

const USER_EXIST_ERROR_MSG =
  'You are already connected to Corvum! Please log in to continue.'
const MAX_MESSAGE_COUNT = 4
const MULTIPLIER = 25

const addToClioSlice = createSlice({
  name: 'addToClio',
  initialState,
  reducers: {
    setProgress: (state, { payload }: PayloadAction<string>) => {
      if (state.maxMessageCount < MAX_MESSAGE_COUNT) {
        state.maxMessageCount++
        state.progress = state.maxMessageCount * MULTIPLIER
      }
      state.checkedBool[payload] = true
    },
    setErrorMessage: (state, { payload }: PayloadAction<any>) => {
      const { message, user } = payload

      const isUserExistError = message === USER_EXIST_ERROR_MSG
      if (user.email && !isUserExistError) state.email = user.email

      state.connection = ''
      state.maxMessageCount = MAX_MESSAGE_COUNT
      state.progress = 0

      state.errorMessage = message
    },
    setConnection: (state, { payload }: PayloadAction<string>) => {
      state.connection = payload
    },
    setRedirectUrl: (state, { payload }: PayloadAction<string>) => {
      state.redirectUrl = payload
    },
    setEmail: (state, { payload }: PayloadAction<any>) => {
      state.email = payload.email
    }
  }
})

export const {
  setProgress,
  setErrorMessage,
  setConnection,
  setRedirectUrl,
  setEmail
} = addToClioSlice.actions
export default addToClioSlice.reducer
